<template>
  <div class="animation-wrap">
    <h1>Contact</h1>

    <figure class="effect-scale">
		<img class="round profile-img" src="@/image/profile3.jpg" width=300px>
		</figure>

    <!-- <h3 class="margin-bottom">Follow me</h3> -->
    <div class="about">
      <h1 class="margin-bottom"><a href="https://twitter.com/masaru_pg" target="_blank">Twitter <font-awesome-icon :icon="['fab', 'twitter']" /></a></h1>
    </div>

    <vs-button @click="popupActivo=true" :color="colorx" :gradient-color-secondary="colorx2" type="gradient">See for trial</vs-button>

    <vs-popup class="holamundo"  title="Follow me" :active.sync="popupActivo">
      <div class="popup-wrap">
        
      <p>
        <a href="https://twitter.com/chobi156" target="_blank" style="font-size:20px"><font-awesome-icon icon="guitar" /> My music account  <font-awesome-icon icon="guitar" /></a>
      </p>
      <img class="profile-im" src="@/image/twipro1.jpg" width=80%>
      <p>
        <a href="https://twitter.com/masaru_pg" target="_blank" style="font-size:20px"><font-awesome-icon icon="book-open" /> My study account  <font-awesome-icon icon="book-open" /></a>
      </p>
      <img class="profile-im" src="@/image/twipro2.jpg" width=80%>
      </div>
    </vs-popup>


  </div>  
</template>

<style scoped>
.popup-wrap {
  text-align: center;
}

.margin-bottom{
  margin-bottom: 10px;
}

  a {
    color: aqua;
  }

</style>

<script>
var container = document.getElementById( "tweet-user-timeline" ) ;

// ユーザータイムラインを埋め込み表示するメソッドを実行
twttr.widgets.createTimeline (
	{	// 第1引数: ウィジェットの種類
		sourceType: "profile" ,
		screenName: "masaru_pg" ,	// スクリーンネーム
	} ,
	container ,	// 第2引数: コンテナの要素
	{	// 第3引数: パラメータ
		width: 300 ,	// 横幅
		tweetLimit: 4 ,	// ツイートの数
	}
) ;

export default {
  data(){
    return {
      popupActivo:false,
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/Contact.vue